"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RgbppSporeTypeMismatchError = exports.RgbppUtxoBindMultiTypeAssetsError = exports.RgbppCkbTxInputsExceededError = exports.InputsOrOutputsLenError = exports.TypeAssetNotSupportedError = exports.InputsCapacityNotEnoughError = exports.UdtAmountNotEnoughError = exports.NoRgbppLiveCellError = exports.NoXudtLiveCellError = exports.NoLiveCellError = exports.IndexerError = exports.CapacityNotEnoughError = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["CapacityNotEnough"] = 100] = "CapacityNotEnough";
    ErrorCode[ErrorCode["IndexerRpcError"] = 101] = "IndexerRpcError";
    ErrorCode[ErrorCode["NoLiveCell"] = 102] = "NoLiveCell";
    ErrorCode[ErrorCode["NoXudtLiveCell"] = 103] = "NoXudtLiveCell";
    ErrorCode[ErrorCode["NoRgbppLiveCell"] = 104] = "NoRgbppLiveCell";
    ErrorCode[ErrorCode["UdtAmountNotEnough"] = 105] = "UdtAmountNotEnough";
    ErrorCode[ErrorCode["InputsCapacityNotEnough"] = 106] = "InputsCapacityNotEnough";
    ErrorCode[ErrorCode["TypeAssetNotSupported"] = 107] = "TypeAssetNotSupported";
    ErrorCode[ErrorCode["InputsOrOutputsLenInvalid"] = 108] = "InputsOrOutputsLenInvalid";
    ErrorCode[ErrorCode["RgbppCkbTxInputsExceeded"] = 109] = "RgbppCkbTxInputsExceeded";
    ErrorCode[ErrorCode["RgbppUtxoBindMultiTypeAssets"] = 110] = "RgbppUtxoBindMultiTypeAssets";
    ErrorCode[ErrorCode["RgbppSporeTypeMismatch"] = 111] = "RgbppSporeTypeMismatch";
})(ErrorCode || (ErrorCode = {}));
class CapacityNotEnoughError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.CapacityNotEnough;
    }
}
exports.CapacityNotEnoughError = CapacityNotEnoughError;
class IndexerError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.IndexerRpcError;
    }
}
exports.IndexerError = IndexerError;
class NoLiveCellError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.NoLiveCell;
    }
}
exports.NoLiveCellError = NoLiveCellError;
class NoXudtLiveCellError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.NoXudtLiveCell;
    }
}
exports.NoXudtLiveCellError = NoXudtLiveCellError;
class NoRgbppLiveCellError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.NoRgbppLiveCell;
    }
}
exports.NoRgbppLiveCellError = NoRgbppLiveCellError;
class UdtAmountNotEnoughError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.UdtAmountNotEnough;
    }
}
exports.UdtAmountNotEnoughError = UdtAmountNotEnoughError;
class InputsCapacityNotEnoughError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.InputsCapacityNotEnough;
    }
}
exports.InputsCapacityNotEnoughError = InputsCapacityNotEnoughError;
class TypeAssetNotSupportedError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.TypeAssetNotSupported;
    }
}
exports.TypeAssetNotSupportedError = TypeAssetNotSupportedError;
class InputsOrOutputsLenError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.InputsOrOutputsLenInvalid;
    }
}
exports.InputsOrOutputsLenError = InputsOrOutputsLenError;
class RgbppCkbTxInputsExceededError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.RgbppCkbTxInputsExceeded;
    }
}
exports.RgbppCkbTxInputsExceededError = RgbppCkbTxInputsExceededError;
class RgbppUtxoBindMultiTypeAssetsError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.RgbppUtxoBindMultiTypeAssets;
    }
}
exports.RgbppUtxoBindMultiTypeAssetsError = RgbppUtxoBindMultiTypeAssetsError;
class RgbppSporeTypeMismatchError extends Error {
    constructor(message) {
        super(message);
        this.code = ErrorCode.RgbppSporeTypeMismatch;
    }
}
exports.RgbppSporeTypeMismatchError = RgbppSporeTypeMismatchError;
